// react
/* eslint-disable */
/* eslint-disable prefer-template */
/* eslint-disable max-len */
// react
import React, { useState, useMemo } from 'react';
import axios from 'axios';
import { MyApiUrl } from '../services/service';

// third-party
import { Helmet } from "react-helmet-async";

// application

// blocks
import BlockBanner from "../blocks/BlockBanner";
import BlockProductsCarousel from "../blocks/BlockProductsCarousel";
import BlockSlideShow from "../blocks/BlockSlideShow";
import HomeSections from "./HomeSections";
import CenterFeatureSection from "./CenterFeatureSection";
import AssociateCompanies from "./AssociateCompanies";

// data stubs
import theme from "../../data/theme";

function HomePageOne() {
    /**
     * Featured products.
     */
    const [ProductData, setProductData] = useState();
    const [ProductView, setProductView] = useState(false);
    const GetAddress = async () => {
        await axios.get(MyApiUrl + "Products").then((response) => {
            if (response.data.length > 0) {
                console.log("Product Data");
                console.log(response.data);
                setProductData(response.data);
                setProductView(true);
            }
            else {
                setProductData([]);
            }
        });
    };

    React.useEffect(() => {
        GetAddress();
    }, []);

    return (
        <React.Fragment>
            <Helmet>
                <title>{`Home Page One — ${theme.name}`}</title>
            </Helmet>

            {useMemo(() => <BlockSlideShow />, [])}

            {useMemo(
                () => (
                    <BlockBanner />
                ),
                [],
            )}

            <HomeSections />

            {ProductView == true ?
                <BlockProductsCarousel
                    title="Featured Products"
                    layout="grid-4"
                    products={ProductData}
                />
                : ""}

            <CenterFeatureSection />

            <AssociateCompanies />

            
        </React.Fragment>
    );
}

export default HomePageOne;
